/* eslint eslint-comments/no-use: off */
/* eslint-disable @github-ui/github-components/require-component-stories */
import {IconButton, type IconButtonProps, Tooltip} from '@primer/react'
import React from 'react'
import {XIcon} from '@primer/octicons-react'

interface FacetNegateButtonProps extends Pick<IconButtonProps, 'onClick'> {
  ariaLabel: string
}

export default React.forwardRef(FacetNegateButtonWithRef)

function FacetNegateButtonWithRef(
  {ariaLabel, onClick}: FacetNegateButtonProps,
  ref: React.ForwardedRef<HTMLButtonElement>,
): JSX.Element | null {
  return (
    <Tooltip aria-label="Exclude from results" direction="nw">
      <IconButton
        sx={{
          color: 'fg.muted',
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
          height: 32,
          width: 32,
        }}
        aria-label={ariaLabel}
        icon={XIcon}
        onClick={onClick}
        ref={ref}
        size="small"
        tabIndex={-1}
        variant="invisible"
      />
    </Tooltip>
  )
}

try{ FacetNegateButtonWithRef.displayName ||= 'FacetNegateButtonWithRef' } catch {}